// Capas/aberturas dos PPTX exportados — usam o layout do template Marini
// (imagens em public/pptx). Cada deck recebe: capa (slide 1 do template) +
// uma abertura específica (Mapa=slide2, Scorecard=slide3, Indicadores=slide4).

const ABERTURA = {
  mapa: "/pptx/abertura-mapa.jpg",
  scorecard: "/pptx/abertura-scorecard.jpg",
  indicadores: "/pptx/abertura-indicadores.jpg",
};

async function toDataUrl(url) {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`falha ao carregar ${url}: ${res.status}`);
  const blob = await res.blob();
  return await new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(blob);
  });
}

/**
 * Carrega as imagens de capa/abertura. Em ambiente sem fetch (ex.: testes Node)
 * ou se as imagens não existirem, retorna null e o deck usa a capa textual padrão.
 * @param {"mapa"|"scorecard"|"indicadores"} kind
 * @param {Object} [override] {capa, abertura} data URLs — usado em testes
 */
export async function loadCovers(kind, override) {
  if (override) return override;
  if (typeof fetch !== "function") return null;
  try {
    const capa = await toDataUrl("/pptx/capa.jpg");
    const abertura = ABERTURA[kind] ? await toDataUrl(ABERTURA[kind]) : null;
    return { capa, abertura };
  } catch (e) {
    console.warn("Capas do template não carregadas — usando capa padrão.", e);
    return null;
  }
}

/**
 * Adiciona os slides de capa + abertura (imagens full-bleed). Retorna o número
 * de slides de introdução adicionados (0, 1 ou 2) para ajustar a numeração.
 */
export function addCoverSlides(pptx, covers, PW, PH) {
  if (!covers || !covers.capa) return 0;
  const s1 = pptx.addSlide();
  s1.background = { color: "FFFFFF" };
  s1.addImage({ data: covers.capa, x: 0, y: 0, w: PW, h: PH });
  if (covers.abertura) {
    const s2 = pptx.addSlide();
    s2.background = { color: "FFFFFF" };
    s2.addImage({ data: covers.abertura, x: 0, y: 0, w: PW, h: PH });
    return 2;
  }
  return 1;
}
